'use strict';
angular.module('cvsApp').factory('refreshTokenModel',[function() {

    var refreshTokenModel = function(){

        var apiResponse = {};

        var that = this;

        this.getResponse = function(){
            return this;
        }

        this.setResponse = function(data){
            apiResponse = cvsUtility.xmlToJSON(data);
        }
        /**
         * SP 01/04/2017 - Updated the logic to check for standard API error response.
         * @returns {*}
         */
        this.getError = function(){
            if(apiResponse.hasOwnProperty("response") &&  (apiResponse.response.header.statusCode !="0000")){
                apiResponse.showError = that.getHeader();
                return apiResponse.showError;
            }
            else if(apiResponse.hasOwnProperty("response") && apiResponse.response.header.statusCode != "0000"){
                apiResponse.showError = apiResponse.response.header;
                return apiResponse.showError;
            }
            return "";
        }

        this.getHeader = function () {
            return apiResponse.response.header;
        }

        this.getresponse = function(){
            if(!apiResponse.showError){
                return apiResponse.response.details;
            }
        }        

    }

    return new refreshTokenModel();

    }]);